<template>
  <div class="QRCode_google">
    <el-dialog :visible.sync="dialogVisible" title="Informe sua Senha" width="30%">
      <el-form v-loading="loadingPage" status-icon :model="ruleFormPass" ref="ruleForm" :rules="rules" @submit.prevent v-on:submit.prevent>
        <el-form-item prop="password" label="Senha" :error="error.password">
          <el-input  size="large"
                     placeholder="● ● ● ● ● ●"
                     v-model="ruleFormPass.password"
                     :type="type" required>
            <i class="el-icon-view el-input__icon" slot="suffix" @click="changeType">
            </i>
          </el-input>
        </el-form-item>
      </el-form>
      <el-dialog
          width="45%"
          :visible.sync="dialogVisible2"
          append-to-body>
        <div style="text-align: center;">
          <strong>Leia este QRCode no seu Google Authenticator</strong>
          <div style="text-align: center;" v-html="svgQRC"></div>
        </div>
      </el-dialog>
      <span slot="footer" class="dialog-footer">
        <el-button style="float: left" @click="dialogVisible = false">Cancelar</el-button>
        <el-button type="primary" @click.prevent="submitFormPass()">Confirmar</el-button>
      </span>
    </el-dialog>
    <el-button type="primary" @click="() => {dialogVisible = true}">Gerar Código</el-button>
  </div>
</template>

<script>
import {
  getEstaComercial,
  getMarketplaces,
  getRepresentantes,
  postGenerateQRCodeGoogle
} from "@/app/domains/Records/services";
import {makeErrorFilds} from "@/app/plugins/utils";
import {mapGetters} from "vuex";

export default {
  name: "QRCode_google",
  props: ['idUser'],
  data () {
    return {
      loadingPage: false,
      dialogVisible: false,
      dialogVisible2: false,
      ruleFormPass: {
        password: ''
      },
      type: 'password',
      rules: {},
      error: {},
      svgQRC: ''
    }
  },
  computed: {
    ...mapGetters('Auth', ['currentUser']),
  },
  methods: {
    gerarCode () {

    },
    async submitFormPass () {
      await this.$refs['ruleForm'].validate(async (valid) => {
        if (valid) {
          try {
            this.loadingPage = true
            let response = {}
            response = await postGenerateQRCodeGoogle({idUser: this.currentUser.id, data: this.ruleFormPass})
            
            this.svgQRC = response.bodyText
            this.dialogVisible2 = true
          } catch (e) {
            
            this.error = makeErrorFilds(e)
            this.$message({
              showClose: true,
              message: makeErrorFilds(e)[Object.keys(makeErrorFilds(e))[0]],
              type: 'error'
            })
          } finally {
            this.loadingPage = false
          }
        }
      })
    },
    changeType (ev) {
      if (this.type === 'password') {
        this.type = 'text'
      } else if (this.type === 'text') {
        this.type = 'password'
      }
    }
  },
  async mounted () {
    
  }
}
</script>

<style scoped>

</style>
